import React, { useEffect } from "react";
import { Form, Radio } from "antd";
import { vitalOptions } from "../../../IpEMR/Options/careItemsOptions";
import { DeleteOutlined } from "@ant-design/icons";

const AiVitalForm = ({ form, onDelete, editData }) => {
  useEffect(() => {
    if (editData?.monitoring?.vitals?.frequency) {
      form.setFieldValue(
        ["care_items", "vitals", "data", "vitals"],
        editData?.monitoring?.vitals?.frequency
      );
    }
  }, [editData]);

  return (
    <div
      style={{
        display: "flex",
        gap: "12px",
        alignItems: "flex-start",
        padding: "12px 0",
      }}
    >
      <div style={{ flex: 1 }}>
        <Form.Item
          name={["care_items", "vitals", "data", "vitals"]}
          label="Vitals"
          rules={[{ required: true, message: "Please select an option" }]}
        >
          <Radio.Group options={vitalOptions} />
        </Form.Item>
      </div>

      <DeleteOutlined
        onClick={() => {
          form.setFieldValue(["care_items", "data", "vitals"], null);
          onDelete();
        }}
        style={{
          color: "red",
          fontSize: 20,
          cursor: "pointer",
          marginTop: 30,
        }}
      />
    </div>
  );
};

export default AiVitalForm;
